import con from '../../../connection';
var path = '/login';
var login = function (url) { return function () { return ({
    post: function (param) { return con.post(url + path, param); },
}); }; };
export default login;
